export default __webpack_public_path__ + "static/media/001.57f4ed63.jpg";